// src/modules/app-views/_apps/appmulti/coupons/pages/Init/actions/actionButton.js
import { PlusOutlined } from '@ant-design/icons';

const couponsInitActionButton = () => {
  return {
    action: 'new',
    hideButton: false,
    label: 'new',
    tooltip: 'new_coupon',
    icon: <PlusOutlined />,
    type: 'primary',
    disabled: false,
    onClick: ({ navigate, setPage }) => {
      setPage({ navigate, pageName: 'document', params: { _id: 'add' } });
    },
    dropdownItems: [],
  };
};

export default couponsInitActionButton;
